import { Text, FormField, Flex, Box, TextField, Select } from '@scale/scaleui-radix';
import useExplainQueueCard from './useExplainQueueCard';
import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';

const ExplainQueueCardComponent: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const { selectedColumnId, setSelectedColumnId, projectId, setProjectId, columns } =
    useExplainQueueCard(index);

  return (
    <div className="flex flex-col gap-8">
      <Text>
        This card will run an explain queue corp job on the selected column of worker ids and may
        take a couple of minutes.
        <br />
        Set the project id to limit the queue run to a specific project.
      </Text>
      <Flex gap="2" direction="column">
        <Box maxWidth="400px">
          <FormField.Root size="3">
            <FormField.Label htmlFor="worker-id-select">Column with Worker IDs</FormField.Label>
            <Select.Root
              value={selectedColumnId}
              onValueChange={(value: string | null) => {
                setSelectedColumnId(value ?? '');
              }}
            >
              <Select.Trigger
                id="worker-id-select"
                placeholder="Select a column with worker ids"
                style={{ width: '400px' }}
              />
              <Select.Content>
                {columns.map(column => {
                  return (
                    <Select.Item key={column.id ?? '-'} value={column.id ?? '-'}>
                      {column.header ?? '-'}
                    </Select.Item>
                  );
                })}
              </Select.Content>
            </Select.Root>
          </FormField.Root>
        </Box>
        <Box maxWidth="400px">
          <FormField.Root size="3">
            <FormField.Label htmlFor="project-id-textfield" required={false}>
              Project ID
            </FormField.Label>
            <TextField.Root
              value={projectId}
              onChange={e => setProjectId(e.target.value)}
              id="project-id-textfield"
            />
          </FormField.Root>
        </Box>
      </Flex>
    </div>
  );
};

export default ExplainQueueCardComponent;
